module.exports = __webpack_public_path__ + "static/img/company-component-cove-5-4.3023b0ee.jpg";